module.exports = __webpack_public_path__ + "img/gn.ea17e71d.svg";